import { Box, Skeleton, TablePagination, Switch } from "@mui/material";
import Card from "components/card";
import { MdDelete, MdEdit, MdVisibility } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { useRestaurant } from "./useRestaurant";
import { BsDatabaseFillX } from "react-icons/bs";

const Restaurant = () => {
  const {
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    userType,
    onDelete,
    restaurantData,
    status,
    onToggleActive,
  } = useRestaurant({});

  const navigate = useNavigate();

  const handleAddRestaurant = () => {
    navigate(`/${userType}/add-restaurant`);
  };

  const handleEditRestaurant = (restaurantId: string) => {
    navigate(`/${userType}/edit-restaurant/${restaurantId}`);
  };

  const handleViewRestaurant = (restaurantId: string) => {
    navigate(`/${userType}/view-restaurant/${restaurantId}`);
  };
  return (
    <div className="flex w-full flex-col gap-5">
      <div className="col-span-5 my-10 lg:col-span-12 lg:mb-0 3xl:!col-span-3">
        <div className="mb-10 flex justify-end lg:mb-0">
          <div className="relative mb-2 w-32">
            {userType !== "branch" && (
              <button
                className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                onClick={handleAddRestaurant}
              >
                Add Restaurant
              </button>
            )}
          </div>
        </div>

        <Card extra={"w-full h-full p-3"}>
          <div className="relative mb-3 items-center justify-between py-10 lg:px-10">
            {status === "loading" ? (
              <Box>
                <Skeleton sx={{ height: 190 }} />
                <Skeleton animation="wave" />
                <Skeleton animation={false} />
              </Box>
            ) : status === "success" && restaurantData?.data?.length !== 0 ? (
              <>
                <Table className="w-full min-w-full table-auto">
                  <Thead>
                    <Tr>
                      <Th className="border-blue-gray-50 border-b px-5 py-3 text-left">
                        Name
                      </Th>
                      <Th className="border-blue-gray-50 border-b px-5 py-3 text-left">
                        Type
                      </Th>
                      <Th className="border-blue-gray-50 border-b px-5 py-3 text-left">
                        Is Active
                      </Th>
                      <Th className="border-blue-gray-50 border-b px-5 py-3 text-center">
                        Actions
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {restaurantData.data.map((restaurant: any, index: any) => (
                      <Tr key={restaurant._id}>
                        <Td className="border-blue-gray-50 border-b px-5 py-3">
                          <p className="font-normal">{restaurant.name.en}</p>
                        </Td>
                        <Td className="border-blue-gray-50 border-b px-5 py-3">
                          <p className="font-normal">
                            {restaurant.branchDetails?.type || "N/A"}
                          </p>
                        </Td>
                        <Td className="border-blue-gray-50 border-b px-5 py-3">
                          <Switch
                            checked={restaurant?.metaData?.isActive}
                            onChange={() => {
                              onToggleActive(
                                restaurant._id,
                                restaurant?.metaData?.isActive
                              );
                            }}
                          />
                        </Td>
                        <Td className="border-blue-gray-50 border-b px-5 py-3 text-center">
                          <div className="flex items-center gap-2 xl:justify-center">
                            <button
                              onClick={() =>
                                handleEditRestaurant(restaurant._id)
                              }
                              className="text-blue-500 hover:underline"
                            >
                              <MdEdit className="h-5 w-5" />
                            </button>
                            {userType !== "branch" && (
                              <button
                                onClick={() => onDelete(restaurant._id)}
                                className="text-red-500 hover:underline"
                              >
                                <MdDelete className="h-5 w-5" />
                              </button>
                            )}
                            <button
                              onClick={() =>
                                handleViewRestaurant(restaurant._id)
                              }
                              className="text-green-500 hover:underline"
                            >
                              <MdVisibility className="h-5 w-5" />
                            </button>
                          </div>
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  className="text-sm font-bold text-navy-700 dark:text-white"
                  count={restaurantData?.totalDocumentCount || 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </>
            ) : (
              <div className="flex w-full flex-col items-center justify-center">
                <BsDatabaseFillX className="h-16 w-16 text-gray-500" />
                <p className="mt-3 text-sm font-bold text-gray-800">No Data</p>
              </div>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Restaurant;
